import React, { useState, useContext } from 'react';
import { Field } from "formik";
import Colors from "constants/Colors";
import { isNumber } from '../../utils';
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext } from 'store/context';
import { Label, CheckBox, Button, HasPermission, InputField } from '@fitinsur/components';
import Icon from 'components/Icon';
import SelectField from '../Form/SelectField';
import {
	TableComponent,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  SmallTitle,
  TableColumn,
  InlineLabel,
  TitleAlter,
  TableColumnCoverageItem
} from './styles';
import './styles.css';

const MultipleProductPlan = ({
	props: {
		calcList,
		history,
		idOperation,
		idProduct,
		formikRef,
		formikValues,
		disabled,
		permissions,
		onRecalculate,
		handleCheckCoverage,
		onRecalculateItem,
		onConfirmPlanText,
		onConfirmPlan,
		disabledCommission,
		selectedOption,
		openHistoryModel,
		disabledConfirm,
		readOnlyMode,
		showHistory,
		showCoveragesAndExtensions,
		hasCoverageCalc,
		showAlterButton,
		minCommission,
		maxCommission,
		isInAnalysis,
		onProductOptions
	},
	coverages,
	option,
	showOption,
	parseNumber,
	currencyMask,
	expanded
}) => {
  const maskHelper = new MasksHelper();
	const authContext = useContext(GlobalAuthContext);

	const [coverageExpanded, setCoverageExpanded] = useState(true);
	
	const formikKey = readOnlyMode ? 'previousCalculationList' : 'calculationList';
	
	const notCoverageProductPlan = (
		<TableColumnCoverageItem 
			colSpan={5} 
			width={20} 
			noBorder={expanded ? true : false} 
			rightBorder={expanded ? true : false}
		>
			<Icon name="not-ok"/>
		</TableColumnCoverageItem>
	);

	const coverageDisabledField = (style) => {
		return <Field
			style={style}
			name={'defaultValueCoverageDisabled'}
			component={InputField}
			type="text"
			alignCenter
			validation={false}
			disabled={true}
			readOnly={true}
		/>
	}

	return (
		<TableComponent>
			<TableHead>
				{(hasCoverageCalc && onProductOptions.length) ? (
					<TableRow>
						<TableHeader colSpan={10}>
							<div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
								<SmallTitle style={{maxWidth: '300px'}}>
									Selecione o(s) produto(s) que deseja contratar:
								</SmallTitle>
								<Field
									style={{ width: '100%'}}
									component={SelectField}
									disabled={readOnlyMode}
									options={onProductOptions || []}
									name='productOptions'
									value={formikValues.productOptions}
									placeholder='Selecione o produto'
									onChange={(value) => formikRef.current.setFieldValue('productOptions', value)}
								/>
								{!readOnlyMode && <div style={{height: '60px', marginLeft: '16px'}}>
									<Button
										disabled={readOnlyMode || disabledConfirm || !permissions.MARKETS_SELECTION}
										id="btnContinue"
										type="button"
										onClick={(e) => {
											e.stopPropagation();
											e.preventDefault();
											onConfirmPlan && onConfirmPlan(formikRef.current.values.productOptions)
										}}
										secondary={true}
									>
										{onConfirmPlanText}
									</Button>
								</div>}
							</div>
						</TableHeader>
					</TableRow>
				) : <></>}
				<TableRow>
					<TableHeader className={'empty-th'} width={300} />
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableHeader 
								colSpan={5} 
								style={{
									textAlign: 'center',
									color: Colors.WHITE,
									borderTopRightRadius: 12,
									borderTopLeftRadius: 12,
								}}
								backgroundColor={Colors.SECONDARY}
								onClick={(e) => {
									if (selectedOption != null) return;
									if (!permissions.NBI_REQUEST_APPROVE_REJECT) return;
									e.stopPropagation();
									showOption(index)
								}}
							>
								<span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<span style={{ flexGrow: 1, textAlign: 'center', marginLeft: '15px' }}>
										{calculations.productName}
									</span>
									<HasPermission permission={!readOnlyMode && permissions?.NBI_REQUEST_APPROVE_REJECT}>
										{(showHistory) ? <Icon 
											name="icon-green_exclamation"
											className={'icon-green_exclamation'}
											style={{ textAlign: 'right', marginRight: '15px' }}
											onClick={(e) => {
												if (selectedOption != null) return;
												e.stopPropagation();
												openHistoryModel && openHistoryModel(index)
											}} 
										/> : <></>}
										<Icon name="icon-arrow-right-white" className={expanded ? 'icon-arrow-left-white' : 'icon-arrow-right-white'} style={{ textAlign: 'right', marginRight: '15px' }} />
									</HasPermission>
								</span>
							</TableHeader>
						)
					})}
				</TableRow>
			</TableHead>
			
			<TableBody>
				<TableRow backgroundColor={Colors.GRAY[4]}>
					<TableColumn style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }} width={100}>
						<SmallTitle>
							Importância Segurada Total
							{!showAlterButton && <TitleAlter 
								onClick={() => {history.push(`/edit-enquiry/${idProduct}/${idOperation}`, { isEdit: true })}}
							>
								Alterar
							</TitleAlter>}
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>
								<Label weight={700}>
									R$ {maskHelper.formatCurrency(authContext, calculations.coverageLimit)}
								</Label>
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<SmallTitle>
							Valor Médio por Embarque (LMG Médio)
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>
								<Label>
									R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations.averageLMG))}
								</Label>
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<SmallTitle>
							Prêmio NET Estimado
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>
								<Label>
									R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations.coverageAmountDiscountLess))}
								</Label>
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<SmallTitle>
							Prêmio Líquido Estimado
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>
								<Label>
									R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations.coverageAmountTaxLess))}
								</Label>
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<SmallTitle>
							Prêmio Mínimo Mensal
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>

								<Field style={{ width: '180px', margin: 'auto' }}
									name={`${formikKey}.${index}.minimumMonthlyPremium`}
									component={InputField}
									disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || !isInAnalysis}
									type="text"
									alignCenter
									mask={currencyMask(permissions.NBI_REQUEST_APPROVE_REJECT ? 0 : 5000, permissions.NBI_REQUEST_APPROVE_REJECT ? 0 : 500)}
									onBlur={(value) => onRecalculate && onRecalculate(
										value,
										index,
										'customMinimumMonthlyPremium',
										calculations.idProductPlan
									)}
								/>
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<SmallTitle>
							Desconto
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>
								{calculations?.idProduct === 50 ?
									coverageDisabledField({ width: '180px', margin: 'auto' }) :
									<Field style={{ width: '180px', margin: 'auto' }}
										name={`${formikKey}.${index}.coveragePremiumDiscountRate`}
										component={InputField}
										disabled={readOnlyMode || !isInAnalysis}
										type="text"
										alignCenter
										mask={{
											type: "percentage",
											mask: '% num',
											blocks: {
												num: {
													mask: Number,
													scale: 5,
													signed: false,
													thousandsSeparator: '',
													padFractionalZeros: true,
													normalizeZeros: false,
													radix: ".",
													max: showCoveragesAndExtensions ? 100 : 50,
													min: showCoveragesAndExtensions ? -100 : -50
												}
											}
										}}
										onBlur={(value) => onRecalculateItem && onRecalculateItem(
											value,
											index,
											null,
											'customCoveragePremiumDiscountRate'
										)}
									/>
								}
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<SmallTitle>
							Comissão
						</SmallTitle>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
								<InlineLabel>
									{calculations.productPlanName}
								</InlineLabel>

								<Field style={{ width: '180px', margin: 'auto' }}
									name={`${formikKey}.${index}.coverageComissionRate`}
									component={InputField}
									disabled={(readOnlyMode || disabledCommission) || (!minCommission && !maxCommission)}
									type="text"
									alignCenter
									mask={{
										type: "percentage",
										mask: '% num',
										blocks: {
											num: {
												mask: Number,
												scale: 5,
												signed: false,
												thousandsSeparator: '',
												padFractionalZeros: true,
												normalizeZeros: false,
												radix: ".",
												max: maxCommission || 100,
												min: minCommission || 0
											}
										}
									}}
									onBlur={(value) => onRecalculate && onRecalculate(
										value / 100,
										index,
										'customComissionRate',
										calculations.idProductPlan
									)}
								/>
							</TableColumn>
						)
					})}
				</TableRow>

				<TableRow>
					<TableColumn width={100}>
						<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
							<SmallTitle>
								Coberturas
							</SmallTitle>
							<Icon 
								className={!coverageExpanded ? 'closed' : ''}
								name="arrow-up-primary-color"
								onClick={() => setCoverageExpanded(!coverageExpanded)}
							/>
						</div>
					</TableColumn>
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return (
							<TableColumn colSpan={5} center>
							</TableColumn>
						)
					})}
				</TableRow>

				{coverageExpanded && showCoveragesAndExtensions &&
					<TableRow>
						{calcList.map((calculations, index) => {
							if (option != null && index != option) return <></>
							return <>
								<TableColumnCoverageItem 
									width={100} 
									style={{ display: index === option ? 'table-cell' : 'none' }} 
								/>
								<TableColumnCoverageItem 
									className={'td-coverage'} 
									style={{ display: index === option ? 'table-cell' : 'none' }} 
									width={100} 
									noBorder={true}
									rightBorder={true}
								>
									<SmallTitle>
										LIMITE POR COBERTURA
									</SmallTitle>
								</TableColumnCoverageItem>
								<TableColumnCoverageItem 
									className={'td-coverage'}
									style={{ display: index === option ? 'table-cell' : 'none' }}
									width={50}
									noBorder={true}
								>
									<SmallTitle>
										% TAXA
									</SmallTitle>
								</TableColumnCoverageItem>
								<TableColumnCoverageItem 
									className={'td-coverage'}
									style={{ display: index === option ? 'table-cell' : 'none' }}
									width={100}
									noBorder={true}
								>
									<SmallTitle>
										PR. NET
									</SmallTitle>
								</TableColumnCoverageItem>
								<TableColumnCoverageItem 
									className={'td-coverage'}
									style={{ display: index === option ? 'table-cell' : 'none' }}
									width={100}
									noBorder={true}
								>
									<SmallTitle>
										PR. LÍQUIDO
									</SmallTitle>
								</TableColumnCoverageItem>
								<TableColumnCoverageItem 
									className={'td-coverage'}
									style={{ display: index === option ? 'table-cell' : 'none' }}
									width={140}
									noBorder={true}
								>
									<SmallTitle>
										FRANQUIA
									</SmallTitle>
								</TableColumnCoverageItem>
							</>
						})}
					</TableRow>
				}

				{coverageExpanded && coverages.map(coverage => {
					const indexCoverage = calcList[option]?.coverageItems?.findIndex(
						cov => cov.idCoverage === coverage.idCoverage
					);
					if((
						indexCoverage === -1 || 
						indexCoverage === null ||
						indexCoverage === undefined
					) && expanded){
						return <></>
					}

					return (
						<TableRow>
							<TableColumnCoverageItem display={'flex'} style={{ textAlign: "left" }}>
								{option != null && <Field
									component={CheckBox}
									name={`${formikKey}.${option}.coverageItems.${indexCoverage}.coverageDisabled`}
									checked={!coverage.coverageDisabled}
									checkValue
									disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled}
									reverseValue
									onChange={(value) => {
										handleCheckCoverage && handleCheckCoverage(
											value, 
											option, 
											coverage.idCoverage,
											calcList[option].idProductPlan
										)
									}} 
								/>}
								<Label>{coverage.coverageName}</Label>
							</TableColumnCoverageItem>

							{calcList.map((calculation, index) => {
								if (option != null && index != option) return <></>
								const indexCoverage = calculation?.coverageItems?.findIndex(
									cov => cov.idCoverage === coverage.idCoverage
								);
								const nameField = `${formikKey}.${index}.coverageItems.${indexCoverage}`;
								const { 
									coverageDisabled,
								} = formikValues?.calculationList[index].coverageItems[indexCoverage] || {};

								const coverageComponent = (<>
									<TableColumnCoverageItem 
										colSpan={index === option ? 1 : 5}
										width={20}
										noBorder={expanded ? true : false}
										rightBorder={expanded ? true : false}
									>
										<InlineLabel>
											LIMITE POR COBERTURA {calculation.productPlanName}
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: option != null ? '80%' : '180px',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
												mask={currencyMask()}
												name={`${nameField}.coverageLimit`}
												component={InputField}
												type="text"
												validation={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled ||
													coverage.coverageDomain === 1
												}
												readOnly={index === option ? false : true}
												onBlur={(value) => index === option && onRecalculateItem && onRecalculateItem(
													value,
													index,
													coverage.idCoverage,
													'customCoverageLimit',
													null,
													calculation.idProductPlan,
													coverage.coverageDomain
												)}
											/>
										}
									</TableColumnCoverageItem>
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											% TAXA
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												mask={maskHelper.getPercentage(authContext.region, 5, "100", "0", true)}
												name={`${nameField}.coverageRate`}
												component={InputField}
												type="text"
												validate={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled ||
													coverage.coverageDomain === 1 && calculation.productName === 'RCTR-C'
												}
												readOnly={false}
												onBlur={(value) => onRecalculateItem && onRecalculateItem(
													value / 100,
													index,
													coverage.idCoverage,
													'customCoverageRate',
													null,
													calculation.idProductPlan
												)}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											PR. NET
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												name={`${nameField}.coveragePremiumDiscountLess`}
												component={InputField}
												type="text"
												validation={false}
												mask={currencyMask()}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled
												}
												readOnly={true}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											PR. LÍQUIDO
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												mask={currencyMask()}
												name={`${nameField}.coveragePremiumTaxLess`}
												component={InputField}
												type="text"
												validation={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled
												}
												readOnly={true}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											FRANQUIA
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '95%',
												margin: "0"
											}) :
											<Field
												style={{ width: '95%', margin: "0" }}
												name={`${nameField}.deductibleDescription`}
												component={InputField}
												type="text"
												validation={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled
												}
												readOnly={false}
												onBlur={(value) => onRecalculateItem && onRecalculateItem(
													value,
													index,
													coverage.idCoverage,
													'customDeductibleDescription',
													null,
													calculation.idProductPlan
												)}
											/>
										}
									</TableColumnCoverageItem>}
								</>)

								return indexCoverage === -1 ? notCoverageProductPlan : coverageComponent;
							})}
						</TableRow>
					)
				})}

				{coverageExpanded && <TableRow>
					<TableColumn />
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return <TableColumn colSpan={5} center/>
					})}
				</TableRow>}
			</TableBody>
		</TableComponent>
	)
}

export default MultipleProductPlan;